import { getVendorDetails } from "views/pages/manage/masters/vendorManagement/helper";
import { useWizard } from "components/wizard/WizardContext"
import { fetchAllPostPromisedData, updateRequest } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { useCallback } from "react";
import { defaultStreamValues } from "../config";


export const useFetchVendorData = () => {
    const { updateValues, dropdowns } = useWizard();

    const fetchVendorData = async (reqObj = {}) => {
        const updatedObj = updateRequest(reqObj);
        const { vendorId } = updatedObj;
        try {
            updateValues("vendorDetailsLoading", true);
            const response = await getVendorDetails(vendorId);
            const updatedResp = {
                ...response,
                fullName: `${response?.vendorFirstName || ""} ${response?.vendorLastName || ""}`.trim()
            };
            await updateValues("vendorDetails", updatedResp);
            await updateValues("vendorType", response?.vendorType)

        } catch (e) {
            console.log(e);
        } finally {
            updateValues("vendorDetailsLoading", false);
        }
    }
    return { fetchVendorData }
}

export const useFetchVendorStudentMappings = () => {
    const { values, setValues } = useWizard();
    const { vendorType } = values;

    const fetchStudentMappingList = useCallback(
        async (url = "", payload = {}, pageNumber = 0, pageSize = 10, streamKey = "") => {
            try {
                setValues(prev => ({
                    ...prev,
                    [streamKey]: {
                        ...prev?.[streamKey],
                        loading: true
                    }
                }));

                const resp = await fetchAllPostPromisedData(
                    `${url}?offset=${pageNumber}&limit=${pageSize}`,
                    payload,
                    "post"
                );

                if (resp?.code == 200) {
                    const listArrayPath = vendorType.toUpperCase() === 'INVIGILATOR' ? resp?.data?.vendorTestMappingList : resp?.data?.vendorPsidMappingList;
                    const list = listArrayPath || [];
                    const hasRecord = list.length > 0;

                    const totalAmount = list.reduce(
                        (sum, row) => sum + (row?.amount || 0),
                        0
                    );

                    setValues(prev => ({
                        ...prev,
                        [streamKey]: {
                            ...prev?.[streamKey],
                            list,
                            hasData: hasRecord,
                            loading: false,
                            totalAmount,
                            paginationInfo: {
                                currPageNo: resp?.data?.currentPage || 0,
                                totalRecords: resp?.data?.totalRecords || 0,
                                totalPage: resp?.data?.totalPage || 0,
                                currPageSize: pageSize
                            }
                        }
                    }));
                }
            } catch (e) {
                console.log(e);
                setValues(prev => ({
                    ...prev,
                    [streamKey]: {
                        ...prev?.[streamKey],
                        loading: false
                    }
                }));
            }
        },
        [setValues]
    );

    return { fetchStudentMappingList };
};
